'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:loginWidget
 * @description
 * # loginWidget
 */
angular.module('gfcmsApp')
  .directive('changePassword', function($location, $q, cfpLoadingBar, appSettings, userService, FlashService) {
    return {
      templateUrl: '/views/changepassword.tpl.html',
      restrict: 'EA',
      scope: {},
      link: function link(scope) {

        scope.changePassword = changePassword;

        scope.changePasswordData = {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null
        };

        scope.changePassword = changePassword;

        function changePassword(valid) {
          if (valid) {
            return requestStart()
              .then(userService.changePassword.bind(null, null, scope.changePasswordData))
              .then(function() {
                  FlashService.Success('Password changed successfully');
                  $location.path('/');
              })
              .catch(function(error) {
                  FlashService.Error(error.message);
              })
              .finally(requestComplete);
          }
        }

        //  Request
        function requestStart() {
          return $q.resolve(cfpLoadingBar.start());
        }

        function requestSuccess(message) {
          return $q.resolve(FlashService.Success(message));
        }

        function requestFailure(error) {
          return $q.resolve(FlashService.ErrorMessage(error));
        }

        function requestComplete() {
          return $q.resolve(cfpLoadingBar.complete());
        }
      }
    };
  });
